import { t } from 'i18next';
import { MerchantKycStatuses } from 'services/merchants/types';

import { DataTableColumn } from 'components/dataTable';

import RoutePath from 'router/path';

import { makeLabels } from 'utils/i18n';

import { PayoutType } from './components/payoutModal/types';

export const KEYS = {
  ROUTE_MATCH: `${RoutePath.Pwc.Accounts.ById}/:route`,
  MAX_MEMO_PREVIEW_LENGTH: 30,
  NO_MEMO_PLACHEHOLDER: '-',
};

export const MESSAGES_NAMESPACE = 'pages.account.edit.sections.settlement';
export const LABELS = makeLabels(
  {
    PAYOUT: {
      PANEL_TITLE: ['settlement.panelTitle', 'Settlement Payout Account'],
      ADD_METHOD: ['settlement.addMethod', 'Add Payout Account'],
      PLACEHOLDER: ['settlement.placeholder', 'No Payout Account Registered'],
      TABLE_COLUMNS: {
        TYPE: ['settlement.tableColumns.type', 'Type'],
        CURRENCY: ['settlement.tableColumns.currency', 'Currency'],
        PAYMENT_RAIL: ['settlement.tableColumns.paymentRail', 'Payment Rail/Network'],
        ACCOUNT_OR_WALLET_NUMBER: ['settlement.tableColumns.accountOrWalletNumber', 'Account/Wallet'],
      },
      TYPES: {
        [PayoutType.Fiat]: ['settlement.types.fiat', 'Fiat'],
        [PayoutType.Crypto]: ['settlement.types.crypto', 'Crypto'],
      },
      MEMO: ['settlement.memo', 'MEMO:'],
      EDIT_MEMO: ['settlement.editMemo', 'EDIT MEMO'],
    },
    ACTIONS: {
      TITLE: ['settlement.actions.title', 'Actions'],
      UPDATE_ACCOUNT: ['settlement.actions.updateAccount', 'Update Payout Account'],
      DELETE_ACCOUNT: ['settlement.actions.deleteAccount', 'Delete Account'],
    },
    DELETE_MODAL: {
      TITLE: ['settlement.deleteModal.title', 'Change Active Account'],
      HEADER: ['settlement.deleteModal.header', 'Are you sure?'],
      CONTENT: [
        'settlement.deleteModal.content',
        "Once confirmed, the current payout account will be removed, and you'll need to add a new one for all future settlement payouts.",
      ],
      CANCEL: ['settlement.deleteModal.cancel', 'Cancel'],
      CONFIRM: ['settlement.deleteModal.confirm', 'Confirm'],
      ERROR: ['settlement.deleteModal.error', 'Unable to delete payout account.'],
    },
  },
  MESSAGES_NAMESPACE,
);

export const PAYOUT_COLUMNS_IDS = {
  TYPE: 'type',
  CURRENCY: 'currency',
  PAYMENT_RAIL: 'paymentRail',
  ACCOUNT_OR_WALLET_NUMBER: 'account',
  IS_MAIN: 'isMain',
  ACTIONS: 'actions',
};

export const PAYOUT_COLUMNS = (): DataTableColumn[] => [
  { id: PAYOUT_COLUMNS_IDS.TYPE, label: t(LABELS.PAYOUT.TABLE_COLUMNS.TYPE) },
  { id: PAYOUT_COLUMNS_IDS.CURRENCY, label: t(LABELS.PAYOUT.TABLE_COLUMNS.CURRENCY) },
  { id: PAYOUT_COLUMNS_IDS.PAYMENT_RAIL, label: t(LABELS.PAYOUT.TABLE_COLUMNS.PAYMENT_RAIL) },
  { id: PAYOUT_COLUMNS_IDS.ACCOUNT_OR_WALLET_NUMBER, label: t(LABELS.PAYOUT.TABLE_COLUMNS.ACCOUNT_OR_WALLET_NUMBER) },
  { id: PAYOUT_COLUMNS_IDS.IS_MAIN, label: null },
  { id: PAYOUT_COLUMNS_IDS.ACTIONS, label: null },
];

export const ALLOWED_KYC_STATUSES: MerchantKycStatuses[] = [MerchantKycStatuses.Approved, MerchantKycStatuses.Active];
